import { ServiceProjectPolicyResponse } from 'types/entity/service-project-policy-response';
import { ServiceProjectStatusResponse } from 'types/entity/service-project-status-response';

export const serviceProjectStatusFilter = (accessPoint: string, serviceProjectStatuses: ServiceProjectStatusResponse[]) => serviceProjectStatuses.find((s) => s.access_point === accessPoint)?.service_project_status;

export const serviceProjectPolicyFilter = (accessPoint: string, serviceProjectPolicies: ServiceProjectPolicyResponse[]) => serviceProjectPolicies.find((p) => p.access_point === accessPoint)?.service_project_policy;
